import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { getValidationRules } from '../validation/validation';
import SIGN_UP_RULES from '../validation/validationRules/signUp';
import UpdateProfileComponent from '../components/profile/Profile/UpdateProfileComponent';
import { validationRules } from './CompanyFormContainer';
import { getCurrentUser } from './selectors/userSelectors';

const mapStateToProps = (state, { location: { state: locationState = {} } }) => ({
    currentUserInfo: getCurrentUser(state),
    locationState,
});

const mergeProps = (
    { ...stateProps, currentUserInfo, locationState: { activePanel = null } },
) => {
    return {
        ...stateProps,
        initialValues: currentUserInfo,
        activePanel,
    }
}

export default connect(mapStateToProps, null, mergeProps)(reduxForm({
    form: 'update-profile',
    validate: getValidationRules([
        'email',
        'firstName',
        'lastName',
    ].concat(validationRules), Object.assign(SIGN_UP_RULES)),
})(UpdateProfileComponent));



// WEBPACK FOOTER //
// ./src/containers/UpdateProfileContainer.js